import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  LinearProgress,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import MessageTypeIcon from '../../../../../../components/MessageTypeIcon';
import { getProcessItem } from '../../../../Services/ProcessesService';

const ProcessMessagesDialog = props => {
  const { open, batchId, handleClose } = props;

  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]);

  const getMessages = async () => {
    const response = await getProcessItem(batchId);
    setMessages(response.data.messages);
    setLoading(false);
  };

  useEffect(() => {
    getMessages();
    // eslint-disable-next-line
  }, []);

  return (
    <Dialog open={open} onClose={() => handleClose()} fullWidth maxWidth="md" aria-labelledby="process-messages-dialog">
      <DialogTitle id="process-messages-dialog">
        <FormattedMessage id="connection.processes.errorMessages.dialogTitle" />
      </DialogTitle>
      <DialogContent>
        {loading && <LinearProgress />}
        <List>
          {messages.map(message => (
            <ListItem>
              <ListItemIcon>
                <MessageTypeIcon messageType={message.messageType} />
              </ListItemIcon>
              <ListItemText
                primary={<FormattedMessage id={`connection.processes.errorMessages.${message.messageType}`} />}
                secondary={message.description}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={() => handleClose()} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ProcessMessagesDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  batchId: PropTypes.string,
};

export default ProcessMessagesDialog;
